import React from 'react';
import './AboutUs.css';

import { PageTitle } from '../../../components';
import { About, Testimonials, Counter, Team, Services, Process, Partners, Skills, NewsletterSection } from '../../../sections';



const AboutUs = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'about us'} page={'about us'} />

      <section className='about-us'>

        <About />
        <Counter />
        <Services />
        <Skills />
        <Process />
        <Testimonials />
        <Team />
        <NewsletterSection />
        <Partners />

      </section>

    </>
  );
}

export default AboutUs;